import { useState, useEffect, useMemo } from "react";
import styles from './index.module.scss'
import Iconfont from '@utils/Iconfont';
import { IMAGE_TYPE, BATCH_IMAGES_TYPE, RESOURCE_TYPE } from '@utils/CONST'
import API from '@api/api'
import { workflowOfSendTask } from '@utils/workflowOfBuildTaskV2';
import { useNavigate } from 'react-router-dom';
import { Popover, Divider } from 'antd';

const BottomBtnGroups = (props) => {
    const { item, isSelectPage, reEditClick, regenerateByTaskId, onCancel, className } = props
    const navigate = useNavigate()
    const [taskId, setTaskId] = useState()
    const [imageId, setImageId] = useState()
    const [imageUrl, setImageUrl] = useState()

    useEffect(() => {
        if (item) {
            setTaskId(item?.taskId.split('_')[0])
            setImageId(item?.results?.[0]?.id)
        }
    }, [item])

    useEffect(() => {
        const fetchImageUrl = async () => {
            if (!taskId || !imageId) return;
            try {
                let res = await API.batchCommonDownload({ taskId: taskId, imageId: imageId });
                if (res?.code != 0) throw new Error(res?.message);
                const image = res.data;
                setImageUrl(image)
            } catch (error) {
                console.error('Failed to fetch image:', error);
            }
        }
        fetchImageUrl();
    }, [taskId, imageId])

    const handleClick = async (jumpTotype, targetType = "inputImage") => {
        let noWaterRes = await API.batchCommonDownload({ taskId: taskId, imageId: imageId })
        if (noWaterRes?.code != 0) throw new Error(noWaterRes?.message)
        const image = noWaterRes.data
        const res = await workflowOfSendTask(jumpTotype, image, targetType)
        if (!res) return
        const { pathname, options } = res
        navigate(pathname, options)
    }

    const extractionClick = () => {
        window.open(imageUrl ? `/home/image_extraction?url=${encodeURIComponent(imageUrl)}` : `/home/image_extraction`, '_blank')
    }

    const resizeClick = () => {
        window.open(imageUrl ? `/home/imageResize?url=${encodeURIComponent(imageUrl)}` : `/home/imageResize`, '_blank')
    }

    const IsEiEdit = useMemo(() => {
        if (!item) return false
        return item.imageType == IMAGE_TYPE.AI_IMAGE_EXTRACTION ||
            item.imageType == IMAGE_TYPE.REMOVE_INPAINT ||
            item.imageType == IMAGE_TYPE.AI_BEAUTY ||
            item.imageType == IMAGE_TYPE.AI_SMART_BEAUTY ||
            item.imageType == IMAGE_TYPE.IMAGE_RESIZE ||
            item.imageType == IMAGE_TYPE.HAND_FIX
    }, [item])

    const MenuLink = ({ icon, label, onClick }) => (
        <p className={styles.footer_text} onClick={(e) => { e.stopPropagation(); onClick && onClick() }}>
            <Iconfont type={icon} className={styles.Icon} />
            {label}
        </p>
    )

    if (!item || IsEiEdit || item?.orgData) return null;

    const col1 = [];
    const col2 = [];
    const col3 = [];

    // --- Visibility Logic based on PicModalFooter ---

    // Change Clothes
    if (item.projectType === BATCH_IMAGES_TYPE.IMAGE_FINER_BATCH ||
        item.projectType === BATCH_IMAGES_TYPE.CHANGE_MODEL_BATCH ||
        item.projectType === BATCH_IMAGES_TYPE.CHANGE_BKG_BATCH ||
        item.projectType === BATCH_IMAGES_TYPE.SIM_RECOLOR_BATCH ||
        item.projectType === BATCH_IMAGES_TYPE.FUSIONWEAR_BATCH ||
        item.projectType === BATCH_IMAGES_TYPE.GRASS_PLANT_BATCH) {
        col1.push({ label: (item.projectType === BATCH_IMAGES_TYPE.FUSIONWEAR_BATCH || item.projectType === BATCH_IMAGES_TYPE.GRASS_PLANT_BATCH) ? '换衣服' : 'AI试衣', icon: 'icon-aiModelOutlined', onClick: () => handleClick(IMAGE_TYPE.CLOTHES, RESOURCE_TYPE.TRYON_MODEL) });
    }

    // Change Model
    if (item.projectType === BATCH_IMAGES_TYPE.TRYON_BATCH ||
        item.projectType === BATCH_IMAGES_TYPE.IMAGE_FINER_BATCH ||
        item.projectType === BATCH_IMAGES_TYPE.CHANGE_BKG_BATCH ||
        item.projectType === BATCH_IMAGES_TYPE.SIM_RECOLOR_BATCH ||
        item.projectType === BATCH_IMAGES_TYPE.FUSIONWEAR_BATCH ||
        item.projectType === BATCH_IMAGES_TYPE.GRASS_PLANT_BATCH) {
        col1.push({ label: '换模特', icon: 'icon-aiModelOutlined', onClick: () => handleClick(IMAGE_TYPE.MODEL) });
    }

    // Change Background
    if (item.projectType === BATCH_IMAGES_TYPE.TRYON_BATCH ||
        item.projectType === BATCH_IMAGES_TYPE.IMAGE_FINER_BATCH ||
        item.projectType === BATCH_IMAGES_TYPE.SIM_RECOLOR_BATCH ||
        item.projectType === BATCH_IMAGES_TYPE.FUSIONWEAR_BATCH ||
        item.projectType === BATCH_IMAGES_TYPE.GRASS_PLANT_BATCH) {
        col1.push({ label: '换背景', icon: 'icon-aiModelOutlined', onClick: () => handleClick(IMAGE_TYPE.BACKGROUND) });
    }

    // Change Glasses
    if (item.projectType === BATCH_IMAGES_TYPE.TRYON_BATCH ||
        item.projectType === BATCH_IMAGES_TYPE.IMAGE_FINER_BATCH ||
        item.projectType === BATCH_IMAGES_TYPE.CHANGE_MODEL_BATCH ||
        item.projectType === BATCH_IMAGES_TYPE.CHANGE_BKG_BATCH ||
        item.projectType === BATCH_IMAGES_TYPE.SIM_RECOLOR_BATCH ||
        item.projectType === BATCH_IMAGES_TYPE.FUSIONWEAR_BATCH ||
        item.projectType === BATCH_IMAGES_TYPE.GRASS_PLANT_BATCH) {
        col1.push({ label: '换眼镜', icon: 'icon-glassesOutlined', onClick: () => handleClick(IMAGE_TYPE.GLASSES_TRYON, RESOURCE_TYPE.GLASSES_TRYON) });
    }

    // Change Pose
    if (item.projectType === BATCH_IMAGES_TYPE.TRYON_BATCH ||
        item.projectType === BATCH_IMAGES_TYPE.IMAGE_FINER_BATCH ||
        item.projectType === BATCH_IMAGES_TYPE.CHANGE_MODEL_BATCH ||
        item.projectType === BATCH_IMAGES_TYPE.CHANGE_BKG_BATCH ||
        item.projectType === BATCH_IMAGES_TYPE.SIM_RECOLOR_BATCH ||
        item.projectType === BATCH_IMAGES_TYPE.FUSIONWEAR_BATCH ||
        item.projectType === BATCH_IMAGES_TYPE.GRASS_PLANT_BATCH) {
        col1.push({ label: '换姿势', icon: 'icon-poseFantasyOutlined', onClick: () => handleClick(IMAGE_TYPE.POSE_TRYON) });
    }

    // Cloth Recolor
    if (item.projectType !== BATCH_IMAGES_TYPE.SIM_RECOLOR_BATCH) {
        col1.push({ label: '服饰换色', icon: 'icon-recolorOutlined', onClick: () => handleClick(IMAGE_TYPE.CLOTH_RECOLOR) });
    }

    // Sim Tryon
    if (item.projectType === BATCH_IMAGES_TYPE.TRYON_BATCH ||
        item.projectType === BATCH_IMAGES_TYPE.IMAGE_FINER_BATCH ||
        item.projectType === BATCH_IMAGES_TYPE.CHANGE_MODEL_BATCH ||
        item.projectType === BATCH_IMAGES_TYPE.CHANGE_BKG_BATCH ||
        item.projectType === BATCH_IMAGES_TYPE.SIM_RECOLOR_BATCH ||
        item.projectType === BATCH_IMAGES_TYPE.FUSIONWEAR_BATCH ||
        item.projectType === BATCH_IMAGES_TYPE.GRASS_PLANT_BATCH) {
        col1.push({ label: '同版型试衣', icon: 'icon-sametryOutlined', onClick: () => handleClick(IMAGE_TYPE.SIM_TRYON, RESOURCE_TYPE.SIM_TRYON) });
    }

    // Change Shoes (Moved to Col 1 bottom or Col 2 top? Let's put in Col 1 as it fits logically)
    if (item.projectType === BATCH_IMAGES_TYPE.TRYON_BATCH ||
        item.projectType === BATCH_IMAGES_TYPE.IMAGE_FINER_BATCH ||
        item.projectType === BATCH_IMAGES_TYPE.CHANGE_MODEL_BATCH ||
        item.projectType === BATCH_IMAGES_TYPE.CHANGE_BKG_BATCH ||
        item.projectType === BATCH_IMAGES_TYPE.SIM_RECOLOR_BATCH ||
        item.projectType === BATCH_IMAGES_TYPE.FUSIONWEAR_BATCH ||
        item.projectType === BATCH_IMAGES_TYPE.GRASS_PLANT_BATCH) {
        col1.push({ label: '换鞋子', icon: 'icon-shoesOutlined', onClick: () => handleClick(IMAGE_TYPE.SHOES, RESOURCE_TYPE.TRYON_SHOES) });
    }

    // --- Col 2 ---

    // Watermark Remove
    if (item.projectType != BATCH_IMAGES_TYPE.WATERMARK_REMOVE_BATCH) {
        col2.push({ label: '去水印', icon: 'icon-removeWatermark', onClick: () => handleClick(IMAGE_TYPE.WATERMARK_REMOVE) });
    }

    // Change Outfit (Fusion Wear)
    if (item.projectType !== BATCH_IMAGES_TYPE.WATERMARK_REMOVE_BATCH && item.projectType !== BATCH_IMAGES_TYPE.FUSIONWEAR_BATCH) {
        col2.push({ label: '换搭配', icon: 'icon-outfitSmallOutlined', onClick: () => handleClick(IMAGE_TYPE.FUSION_WEAR, RESOURCE_TYPE.FUSIONWEAR_MODEL) });
    }

    // Go to Grass
    if (item.projectType !== BATCH_IMAGES_TYPE.WATERMARK_REMOVE_BATCH &&
        item.projectType !== BATCH_IMAGES_TYPE.GRASS_PLANT_BATCH) {
        col2.push({ label: '去种草', icon: 'icon-sProductshowcaseOutlined', onClick: () => handleClick(IMAGE_TYPE.GRASS_PLANT) });
    }

    // Image to Video
    col2.push({ label: '图生视频', icon: 'icon-tryonVideoOutlined', onClick: () => handleClick(IMAGE_TYPE.IMAGE_TO_VIDEO) });

    // Motion Mimic
    if (item.projectType === BATCH_IMAGES_TYPE.TRYON_BATCH ||
        item.projectType === BATCH_IMAGES_TYPE.IMAGE_FINER_BATCH ||
        item.projectType === BATCH_IMAGES_TYPE.CHANGE_MODEL_BATCH ||
        item.projectType === BATCH_IMAGES_TYPE.CHANGE_BKG_BATCH ||
        item.projectType === BATCH_IMAGES_TYPE.SIM_RECOLOR_BATCH ||
        item.projectType === BATCH_IMAGES_TYPE.FUSIONWEAR_BATCH ||
        item.projectType === BATCH_IMAGES_TYPE.GRASS_PLANT_BATCH) {
        col2.push({ label: '动作模仿', icon: 'icon-tryonVideoOutlined', onClick: () => handleClick(IMAGE_TYPE.MODEL_VIDEO) });
    }

    // Commodity Recolor
    if (item.projectType === BATCH_IMAGES_TYPE.TRYON_BATCH ||
        item.projectType === BATCH_IMAGES_TYPE.IMAGE_FINER_BATCH ||
        item.projectType === BATCH_IMAGES_TYPE.CHANGE_MODEL_BATCH ||
        item.projectType === BATCH_IMAGES_TYPE.CHANGE_BKG_BATCH ||
        item.projectType === BATCH_IMAGES_TYPE.SIM_RECOLOR_BATCH ||
        item.projectType === BATCH_IMAGES_TYPE.WATERMARK_REMOVE_BATCH ||
        item.projectType === BATCH_IMAGES_TYPE.FUSIONWEAR_BATCH ||
        item.projectType === BATCH_IMAGES_TYPE.GRASS_PLANT_BATCH) {
        col2.push({ label: '商品换色', icon: 'icon-recolorOutlined', onClick: () => handleClick(IMAGE_TYPE.COMMODITYRECOLOR) });
    }

    // Commodity Change Back
    if (item.projectType === BATCH_IMAGES_TYPE.WATERMARK_REMOVE_BATCH ||
        item.projectType === BATCH_IMAGES_TYPE.IMAGE_FINER_BATCH) {
        col2.push({ label: '商品换背', icon: 'icon-commidityOutlined', onClick: () => handleClick(IMAGE_TYPE.COMMODITY) });
    }


    // --- Col 3 ---

    // Hand Repair
    col3.push({ label: '修手', icon: 'icon-handRepairOutlined', onClick: () => navigate("/home/aiEdit", { state: { menuKey: 'handRepair', picUrl: imageUrl } }) });

    // Matting
    col3.push({ label: '抠图', icon: 'icon-mattingOutlined', onClick: extractionClick });

    // Resize
    col3.push({ label: '改尺寸', icon: 'icon-picResizeOutlined', onClick: resizeClick });

    // Magic Erase
    col3.push({ label: '去杂物', icon: 'icon-magicRemoveOutlined', onClick: () => navigate("/home/aiEdit", { state: { menuKey: 'magicErase', picUrl: imageUrl } }) });

    // Fill Light
    col3.push({ label: '修光影', icon: 'icon-lightIconOutlined', onClick: () => navigate("/home/aiEdit", { state: { menuKey: 'filllight', picUrl: imageUrl } }) });


    const popover = (
        <div className={styles.popoverContent} onClick={(e) => e.stopPropagation()}>
            <div className={styles.popoverContentLeft}>
                {col1.map((btn, idx) => (
                    <MenuLink key={`col1-${idx}`} icon={btn.icon} label={btn.label} onClick={btn.onClick} />
                ))}
            </div>

            <Divider type="vertical" style={{ height: 'auto', minHeight: '150px', marginRight: '20px' }} />

            <div className={styles.popoverContentMiddle}>
                {col2.map((btn, idx) => (
                    <MenuLink key={`col2-${idx}`} icon={btn.icon} label={btn.label} onClick={btn.onClick} />
                ))}
            </div>

            <Divider type="vertical" style={{ height: 'auto', minHeight: '150px', marginRight: '20px' }} />

            <div className={styles.popoverContentRight}>
                {col3.map((btn, idx) => (
                    <MenuLink key={`col3-${idx}`} icon={btn.icon} label={btn.label} onClick={btn.onClick} />
                ))}
            </div>
        </div>
    )

    return (
        <div className={`${styles.BottomBtnGroups} ${className || ''}`} onClick={(e) => e.stopPropagation()}>
            <div className={styles.MoreOutMenuContent}>
                <Popover placement="top" content={popover} overlayClassName="pic-result-popover">
                    <span className={`${styles.spanItem} ${styles.spanItem2}`}><Iconfont type="icon-menuOutlined" /></span>
                </Popover>
            </div>
        </div>
    )
}

export default BottomBtnGroups